import { Suspense, lazy } from 'react'
import PrivateRoute from '../../auth/PrivateRoute'
import Spinner from '../Spinner';
// import Calendar from "../calendar/Calendar"
import Flight from "../flights/flight-search/Flight"
import FlightSpecialFare from "../flights/flight-search/FlightSpecialFare"

const Calendar = lazy(() => import('../calendar/Calendar'))
const AirPassengerCalendar = lazy(() => import('../calendar/AirPassengerCalendar'))
// const Flight = lazy(() => import('../flights/flight-search/Flight'))
const FlightBooking = lazy(() => import('./flight-booking/FlightBooking'))
const FlightSearchResults = lazy(() => import('./flight-results/FlightSearchResults'))
const SomethingWrong = lazy(() => import('./Somethingwentwrong/SomethingWrong'))

const FlightRoutes = ({ match }) => (
    <div>
        <Suspense fallback={<Spinner />}>
        <PrivateRoute exact path={match.url} component={Flight}/>
        </Suspense>
        <Suspense fallback={<Spinner />}>
        <PrivateRoute exact path={match.url + '/specialfare'} component={FlightSpecialFare}/>
        </Suspense>
        <Suspense fallback={<Spinner />}>
        <PrivateRoute exact path={match.url + '/search'} component={FlightSearchResults}/>
        </Suspense>
        <Suspense fallback={<Spinner />}>
        <PrivateRoute exact path={match.url + '/booking'} component={FlightBooking}/>
        </Suspense>
        <Suspense fallback={<Spinner />}>
        <PrivateRoute exact path={match.url + '/calendar'} component={Calendar}/>
        </Suspense>
        <Suspense fallback={<Spinner />}>
        <PrivateRoute exact path={match.url + '/airPassengerCalendar'} component={AirPassengerCalendar}/>
        </Suspense>
        <Suspense fallback={<Spinner />}>
        <PrivateRoute exact path={match.url + '/failed'} component={SomethingWrong}/>
        </Suspense>

    </div>
)
export default FlightRoutes
